import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { ApiUrls } from '../utilities/APIUris';
import { AddUpdateOrganizationInput, OrganizationProfile, updateMyPasswordInput, updateMyProfileInput } from '../models/profile.model';
import { Observable, of } from 'rxjs';
// import { TableData } from 'src/app/shared-module/modules/gridview/gridview.model';
import { ProjectAddEditResponse, ProjectItem, ProjectListResponse, ProjectListQueryParams, ProjectMemberList, ProjectMemberListQueryParams, ProjectMemberListResponse, ProjectMemberAddingOptions, ProjectMemberAddingPayload, ProjectMemberMappingResponse, ProjectMemberRemoveResponse, ProjectDeleteResponse, validInvitationResponse, DeleteResponse, resendEmail } from '../models/project.model';
import { AuthService } from './auth.service';
import { CommonDataService } from './common-data.service';
import { ApiHandlerService } from './api-hanler.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  orgId: string = '';
  constructor(private router: Router, private http: HttpService, private authService: AuthService, private commonDataService: CommonDataService, private apiHandlerService: ApiHandlerService) {
    this.orgId = this.authService.loggedInUserIdOrgId;
  }

  getList(queryParams?: ProjectListQueryParams): Observable<ProjectListResponse> {
    return this.http.get<ProjectListResponse>(ApiUrls.getProjects.replace('{orgId}', this.orgId), queryParams);
  }

  getDetail(projectId: string): Observable<ProjectItem> {
    return this.http.get<ProjectItem>(ApiUrls.getProjectDetail.replace('{orgId}', this.orgId).replace('{projectId}', projectId));
  }

  getAllMemberList(queryParams: ProjectMemberListQueryParams, projectId: string): Observable<ProjectMemberListResponse> {
    return this.http.get<ProjectMemberListResponse>(ApiUrls.projectTeamList.replace('{orgId}', this.orgId).replace('{projectId}', projectId), queryParams);
  }

  getOrgUsers(projectId: string): Observable<ProjectMemberAddingOptions[]> {
    return this.http.get<ProjectMemberAddingOptions[]>(ApiUrls.projectUserList.replace('{orgId}', this.orgId).replace('{projectId}', projectId));
  }

  mappTheUsers(projectId: string, payload: ProjectMemberAddingPayload): Observable<ProjectMemberMappingResponse> {
    return this.http.put<ProjectMemberMappingResponse>(ApiUrls.projectTeamList.replace('{orgId}', this.orgId).replace('{projectId}', projectId), payload);
  }

  removeUserMapping(projectId: string, userMappingId: string): Observable<ProjectMemberRemoveResponse> {
    return this.http.delete<ProjectMemberRemoveResponse>(ApiUrls.projectRemoveUser.replace('{orgId}', this.orgId).replace('{projectId}', projectId).replace('{userMappingId}', userMappingId));
  }

  getControllerById(controllerID: string){
    return this.apiHandlerService.doGet<any>(ApiUrls.getControllerById.replace('{controller_id}', controllerID), true, true);
  }

  getAllMembersOfController(controllerID: string){
    return this.apiHandlerService.doGet<any>(ApiUrls.getAllMembersOfController.replace('{:controller_id}', controllerID), true, true);
  }

  inviteMemberToController(controllerID: string, payload: any) {
    return this.apiHandlerService.doPost(ApiUrls.inviteMemberToController.replace('{controller_id}', controllerID), payload, true, true)
  }

  validateControllerInvitation(queryString: string): Observable<validInvitationResponse> {
    return this.apiHandlerService.doGet<validInvitationResponse>(ApiUrls.validateControllerInvitation.replace('{queryString}', queryString), true, true)
  }

  acceptControllerInvite(queryString: any) {
    return this.apiHandlerService.doPost(ApiUrls.acceptControllerInvite, queryString, true, true)
  }

  deleteInvitedUser(controllerId: string, emailId: string): Observable<DeleteResponse> {
    return this.apiHandlerService.doDelete<DeleteResponse>(ApiUrls.deleteInvitedMember.replace('{controller_id}', controllerId).replace('{email}', emailId), true, true)
  }

  resendInvitation(controllerId: string, email: resendEmail) {
    return this.apiHandlerService.doPost(ApiUrls.resendInvitation.replace('{controller_id}', controllerId), email, true, true)
  }

}
